import { render, staticRenderFns } from "./ProductSelectSectionContainer.vue?vue&type=template&id=1a7256e4&lang=html&"
import script from "./ProductSelectSectionContainer.vue?vue&type=script&lang=ts&"
export * from "./ProductSelectSectionContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports